import React, { useContext } from 'react';
import noop from 'lodash/noop';

export const TrackingContext = React.createContext({ trackEvent: noop });

export function useTracking() {
  return useContext(TrackingContext);
}
